import styled from "@emotion/styled";
import colors from "styles/colors";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { CLEAN_FIRST_FOLD_MARGIN } from "constants/pricing-sizes";
import { MODAL_BACKGROUND } from "/constants/z-index";
import { BRAND_DARK_COLOR, GAINSBORO_COLOR_NAME } from "styles/color-consts";
export const StyledProductPriceAndFeatures = styled.div`
  .security-logos {
    display: flex;
    gap: 24px;
    margin-top: 38px;
    align-items: center;

    .logo {
      width: 40px;
      height: 40px;
    }

    .white-glove-migration {
      font-size: 12px;
      font-weight: 600;
      color: #007f9b;
    }
    .logos-container {
      display: flex;
      align-items: center;
      gap: 24px;
    }
  }

  .horizontal-line {
    display: block;
    width: 100%;
    border-bottom: 2px solid #c5c7d0;
    margin: 24px 0;
  }

  .signup-form-wrapper {
    input {
      width: 100% !important;
      min-width: 0px !important;
    }
  }

  &.card {
    min-width: 0;
    flex: 1 0 0;
    border-radius: 4px;
    border: 1px solid #d5d5d5;
    padding: 16px;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;

    .icons {
      height: 45px;
      display: flex;
      .icon {
        flex-shrink: 0;
        border: solid 1px;
        border-radius: 8px;
        width: 42px;
        height: 42px;
        padding: 4px;
        margin-right: 8px;
        color: #292f4c;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: var(--product-color);
      }
    }

    .addon-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
      color: #333333;
    }

    .tier-title-container {
      height: ${({ isCrmClassic })=>isCrmClassic ? "35px" : "50px"};
      align-self: stretch;
    }

    .tier-title {
      margin: 8px 0;
      font-size: 1.238rem;
      color: #333333;
      letter-spacing: -0.36px;
      display: flex;
      align-items: center;
      position: relative;
      max-width: calc(100% - 80px);
      .product-and-tier {
        & > div {
          float: left;
        }
      }

      &.new-pricing {
        font-size: 24px;
        font-weight: 700;
      }

      .tier {
        font-weight: bold;
        margin-right: 4px;
      }

      .most-popular-badge-container {
        flex-grow: 1;
      }

      .most-popular-badge {
        font-weight: 700;
        font-size: 0.8125rem;
        line-height: 16px;
        border-radius: 4px;
        width: 66px;
        padding: 8px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 16px;
        z-index: 2;
        color: white;
        &::before {
          z-index: 1;
          content: "";
          position: absolute;
          transform: rotate(45deg);
          width: 14px;
          height: 14px;
          left: -7px;
          top: calc(50% - 7px);
          display: block;
        }
      }
      .most-popular-badge,
      .most-popular-badge::before {
        background-color: ${({ styleColor })=>styleColor};
      }
    }
    &.is-most-popular {
      box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
      .cta-button .ladda-button-component .signup-button,
      .cta-button .ladda-button-component .cta-button {
        color: black;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100px;
        height: 60px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0.14%,
          rgba(211, 127, 232, 0.09) 50.14%,
          rgba(48, 218, 218, 0.14) 100.14%
        );
        filter: blur(25px);
        pointer-events: none;
        z-index: 1;
      }
    }

    .contact {
      height: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "96px" : isNewPricing ? "120px" : "140px"};
      padding: ${({ isCrmClassic })=>isCrmClassic ? "8px 0" : "16px 0"};
      & > div {
        font-weight: 600;
      }

      .crm-ultimate-price {
        display: flex;
        gap: 12px;
        align-items: center;

        svg {
          width: 45px;
          height: 35px;
          flex-shrink: 0;
        }
      }

      .crm-ultimate-price-text {
        font-size: 13px;
        line-height: 20px;
        font-weight: 400;
        color: #323338;
        text-align: left;
      }
    }

    .credits-section-wrapper {
      display: flex;
      flex-direction: column;
      .price,
      .contact {
        height: auto;
        min-height: 0;
      }
    }

    .credits-section-wrapper .price {
      min-height: 138px;
    }

    .contact.enterprise-contact {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      min-height: 138px;
      padding: 0;
      gap: 8px;

      & > div {
        font-weight: 400;
      }

      .enterprise-icon-and-price {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;

        & > svg {
          width: 71px;
          height: 70px;
          flex-shrink: 0;
        }
      }

      .enterprise-custom-price {
        font-size: 16px;
        line-height: 22px;
        font-weight: 400;
        color: #323338;
        white-space: pre-line;
        text-align: left;
      }

      .enterprise-description-text {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: #323338;
      }
    }

    .enterprise-discounts-available {
      font-size: 14px;
      line-height: 19.6px;
      font-weight: 600;
      color: #0f9b63;
      margin-top: 24px;
      margin-bottom: 12px;
    }

    .cta-button {
      width: ${({ isContactUsCard, isMobileOrTabletBrowser })=>isContactUsCard || !isMobileOrTabletBrowser ? "auto" : "100%"};
      &.try-cta-padding {
        padding-bottom: 64px;
      }
      padding: 0 0 8px 0;
      .ladda-button-component .signup-button,
      .ladda-button-component .cta-button {
        background-color: transparent;
        border: 1px solid black;
        color: black;
        letter-spacing: 0.4px;
        * {
          font-weight: bold;
        }
      }
      .ladda-button-component .signup-button:hover,
      .ladda-button-component .cta-button:hover {
        border-color: ${({ ctaHoverBorderColor })=>ctaHoverBorderColor};
        background-color: ${({ ctaHoverBackgroundColor })=>ctaHoverBackgroundColor};
        color: ${({ ctaHoverTextColor })=>ctaHoverTextColor};
        filter: none;
      }
    }

    .pricing-signup-purchase-now {
      display: flex;
      gap: 5px;
      margin-bottom: ${CLEAN_FIRST_FOLD_MARGIN};
      height: 20px;
    }

    .purchase-now-link {
      font-weight: bold;
      text-decoration-line: underline;
    }

    .description {
      font-size: 0.875rem;
      line-height: 24px;
      height: 70px;
      letter-spacing: -0.36px;
      color: #676879;

      &.--no-space {
        height: auto;
        margin-top: 0;
      }
    }

    .enterprise-section-heading {
      font-family: var(--brand-font-family);
      font-size: 16px;
      font-weight: 600;
      line-height: 18.4px;
      color: #323338;
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .feature {
      font-size: 0.844rem;
      margin-bottom: 16px;
      display: flex;
      align-self: stretch;
      align-items: center;
      justify-content: space-between;
      .icon {
        position: relative;
        margin-left: ${({ isNewPricing })=>!isNewPricing ? "6px" : "0px"};
        margin-right: 2px;
        .tooltip {
          z-index: ${MODAL_BACKGROUND};
          display: none;
          opacity: 0;
          position: absolute;
          bottom: calc(100% + 16px);
          transform: translateX(-50%);
          transition: opacity 0.2s ease;
          width: 300px;
          .floating-tooltip {
            position: relative;
            white-space: normal;
            text-align: left;
          }
        }
        &:hover {
          .tooltip {
            display: block;
            opacity: 1;
            transform: translateX(-24.8%);
          }
        }
      }
      .name-and-label {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      &.tooltip-on-text {
        .name-and-label {
          position: relative;
          cursor: default;
          .tooltip {
            z-index: ${MODAL_BACKGROUND};
            display: none;
            opacity: 0;
            position: absolute;
            bottom: calc(100% + 12px);
            left: 0;
            transition: opacity 0.2s ease;
            width: 260px;
            .floating-tooltip {
              position: relative;
              white-space: normal;
              text-align: left;
            }
          }
          &:hover .tooltip {
            display: block;
            opacity: 1;
          }
        }
      }
    }
    ${({ isCrmClassic })=>isCrmClassic ? `
    .feature {
      margin-bottom: 12px;
    }
    .feature .name-and-label {
      color: #323338;
    }
    .feature .name-and-label .feature-secondary {
      color: #676879;
    }
    ` : ""}
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .ladda-button-component {
      .cta-button {
        .signup-form {
          input {
            min-width: 240px;
          }
        }
      }
    }
  }
`;
export const StyledProductPriceAndFeaturesWrapper = styled.div`
  &.card-container {
    &.is-homepage-pricing {
      display: flex;
      flex-direction: column;
      margin-top: 30px;
      position: relative;

      .enterprise-disclaimer {
        position: absolute;
        bottom: -28px;
        left: 0;
        font-size: 12px;
        color: ${colors.asphalt};
        text-align: left;
        white-space: nowrap;
      }

      .most-popular {
        background: ${({ isNewPricing })=>isNewPricing ? "#00D2D2" : colors[BRAND_DARK_COLOR]};
        text-align: center;
        padding: 4px;
        border-radius: 16px 16px 0px 0px;
        .most-popular-span {
          color: white;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px;
        }
      }
      .card {
        border-radius: 16px;
        margin-top: 16px;
        padding: 20px;

        &.is-most-popular {
          border-color: ${({ isNewPricing })=>isNewPricing ? "#00D2D2" : "var(--primary-color)"};
        }

        .tier-title {
          max-width: 100%;
          .coming-soon {
            padding: 1px 8px;
            margin-left: 8px;
            justify-content: center;
            align-items: center;
            border: 1px solid ${colors.asphalt};
            border-radius: 4px;
            font-size: 14px;
            line-height: 22px;
          }
        }

        .amount {
          font-family: var(--brand-font-family);
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          letter-spacing: -1px;
          margin-right: 8px;
        }
        .price-tag {
          align-items: center;
          display: flex;
          font-size: 16px;
          font-family: Sofia Pro;
          font-weight: 400;
        }
        .cta-button {
          width: 100%;
          border: none;
          padding: 0 0 8px 0;

          .ladda-button-component .signup-button,
          .ladda-button-component .cta-button {
            background-color: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "#0074FD" : isNewPricing ? "#323338" : "var(--primary-color)"};
            color: white;
            letter-spacing: 0.4px;
            max-width: none;
            width: 100%;
            border: none;
            padding: 12px 12px;
            &:hover {
              background-color: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "#0074FD" : isNewPricing ? "#323338" : "var(--secondary-color)"};
            }
          }
          .ladda-button-component .contact-us-button {
            border-color: 9px solid black;
            border: 1px solid ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "#0074FD" : isNewPricing ? "#323338" : "var(--secondary-color)"};
            background-color: transparent;
            color: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "#0074FD" : isNewPricing ? "#323338" : "var(--secondary-color)"};

            .ladda-label {
              font-weight: 400;
              font-size: 14px;
            }
            &:hover {
              background-color: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "#0074FD" : isNewPricing ? "#323338" : "var(--secondary-color)"};
              color: white;
            }
          }
          .signup-form {
            display: inherit;
            width: 100%;
          }
          .signup-button-wrapper {
            width: inherit;
          }
          .signup-text {
            font-weight: 400;
            font-size: 14px;
            gap: 10px;
          }
        }

        .description {
          height: ${({ isCrmClassic })=>isCrmClassic ? "48px" : "70px"};
          font-size: 14px;
          font-style: normal;
          margin: ${({ isNewPricing, isCrmClassic })=>isCrmClassic ? "0 0 20px 0" : isNewPricing ? "18px 0 12px 0" : "0px"};
          font-weight: 400;
          font-family: inherit;
          line-height: 22px;
          letter-spacing: normal;
          display: flex;
          color: ${({ isNewPricing })=>isNewPricing ? "#323338" : "#676879"};
        }

        .info-icon {
          height: 12px;
          width: 12px;
        }
        &.is-most-popular {
          margin-top: 0px;
          padding-top: 5px;
          border-radius: 0px 0px 16px 16px;
          border-top: none;
          box-shadow: none;
        }

        .tier-ai-block-wrapper {
          align-self: stretch;
          width: 100%;
          min-height: 114px;
          flex-shrink: 0;

          &.simplified {
            min-height: 0;
          }
        }

        /* Ultimate: exact Figma grouped spacing. The collapsed AI box carries a
           24px bottom margin, so the sections start 24px below it. Nested flex
           gaps drive every internal gap; per-row margins are zeroed. */
        .crm-ultimate-sections {
          align-self: stretch;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 32px;

          .crm-section {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
          .crm-rows {
            display: flex;
            flex-direction: column;
          }
          .crm-rows--icons {
            gap: 16px;
          }
          .crm-rows--values {
            gap: 12px;
          }
          .crm-rows--peruser {
            gap: 8px;
          }
          .feature {
            margin-bottom: 0;
          }
          .enterprise-section-heading {
            margin: 0;
          }
        }

        /* CRM classic bottom "Includes <tier>, plus:" rows sit 8px apart (Figma);
           the flex gap replaces the shared 16px .feature bottom margin so the
           section reads tighter without affecting the top feature list. */
        .crm-per-user-features {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-self: stretch;

          .feature {
            margin-bottom: 0;
          }
        }

        .expandable-bundle {
          margin-bottom: 16px;
          min-width: 252px;
        }
        .tier-include {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .crm-white-glove-migration {
          display: flex;
          align-items: center;
          gap: 24px;
          /* The bottom section rows now zero their own margin (see
             .crm-per-user-features), so the full 24px Figma gap lives here. */
          margin-top: 24px;
          .logo {
            width: 40px;
            height: 40px;
            flex-shrink: 0;
          }
          .wgm-divider {
            width: 1px;
            height: 24px;
            flex-shrink: 0;
            background-color: #d0d4e4;
          }
          .wgm-text {
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            text-transform: uppercase;
            color: #007f9b;
          }
        }
        .tier-learn-more-button {
          height: 32px;
          display: block;
          align-self: center;
          margin-bottom: 14px;
        }
        .play-wrapper,
        .secondary-button-text {
          color: var(--secondary-color);
        }
        .feature {
          .icon {
            .tooltip {
              transform: translateX(-25.4%);
            }
          }
        }
      }
      .currency-sign {
        font-size: 48px;
        font-weight: 100;

        &.bold {
          font-weight: bold;
        }
      }
      .horizontal-line {
        width: 100%;
        border-bottom: 1px solid;
        border-color: ${colors[GAINSBORO_COLOR_NAME]};
      }
    }
  }
`;
